module.exports = __webpack_public_path__ + "img/icon_notif.7f85fbf0.svg";